// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import notesApi from '~/apis/notes';
import {
  CREATE_NOTE,
  CREATE_NOTE_SCHEDULE,
  DELETE_NOTE,
  GET_LIST_NOTE,
  GET_NOTE_SCHEDULE_LIST,
  UPDATE_NOTE,
} from '~/utils/constants/actionType';
import { IFormNote, IQueryGetListNote, IQueryUpdateNote } from '~/utils/interface/note';
import { IFormNoteSchedule, IParamNoteSchedule } from '~/utils/interface/schedule';

export const createNoteSchedule = createAsyncThunk(
  CREATE_NOTE_SCHEDULE,
  async (payload: IFormNoteSchedule, { rejectWithValue }) => {
    try {
      const resp = await notesApi.createNoteSchedule(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getNoteScheduleList = createAsyncThunk(
  GET_NOTE_SCHEDULE_LIST,
  async (params: IParamNoteSchedule, { rejectWithValue }) => {
    try {
      const resp = await notesApi.getNoteScheduleList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListNote = createAsyncThunk(
  GET_LIST_NOTE,
  async (params: IQueryGetListNote, { rejectWithValue }) => {
    try {
      const resp = await notesApi.getListNote(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createNote = createAsyncThunk(CREATE_NOTE, async (body: IFormNote, { rejectWithValue }) => {
  try {
    const resp = await notesApi.createNote(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateNote = createAsyncThunk(
  UPDATE_NOTE,
  async (payload: IQueryUpdateNote, { rejectWithValue }) => {
    try {
      const resp = await notesApi.updateNote(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteNote = createAsyncThunk(DELETE_NOTE, async (noteId: string, { rejectWithValue }) => {
  try {
    const resp = await notesApi.deleteNote(noteId);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
